import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Basket {
  export interface IBasket {
    rows: IBasketRow[];
  }

  export interface ITrackingData {
    actionOrigin: string,
    searchProductOrigin: string;
    sponsorshipId?: string;
  }

  export interface IBasketRow {
    productId?: string;
    searchProductId?: string;
    salesUnitCode?: string;
    rowId?: string;
    setQty?: number;
    changeQty?: number;
    trackingData?: ITrackingData;
    properties?: { [key: string]: string; };
    purchaseType?: IPurchaseType;
    subscriptionOptions?: ISubscriptionOptions;
  }

  export interface BasketValidation {
    basketId: string;
    rowValidations: BasketRowValidation[];
    isValid: boolean;
  }

  export interface BasketRowValidation {
    basketRowId: string;
    errorCodes: string[];
    isValid: boolean;
  }

  export interface ISubscriptionOptions {
    optionId: string;
    qty?: number;
  }
  export enum IPurchaseType {
    OneTimePurchase,
    Subscription
  }
  export const UpdateBasket = async (
    data: IBasket,
    token: string
  ): Promise<any> => {
    const url = `/api/basket?handler=save`;
    return easyfyAxios.post(
      url,
      data,
      token
    );
  };

  export const GetBasket = async (): Promise<any> => {
    const url = `/api/basket`;
    return easyfyAxios.get(
      url
    );
  };

  export const SyncBasketFromCart = async (): Promise<any> => {
    const url = `/api/basket?handler=syncbasketfromcart`;
    return easyfyAxios.post(
      url,
      null
    );
  };
}

export default Easyfy.Web.Services.Basket;